import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import Pagination from '../pagination/Pagination.jsx'
import Button from '../Button.jsx'
import Flash from '../flash/Flash.jsx'
import { ListTournamentsAdmin } from '../../repo/TournamentsRepo.js'
import { DeleteTournament } from '../../repo/TournamentsRepo.js'

export default function AdminTournamentsList() {
  const [searchParams] = useSearchParams();
  const page = searchParams.get('page') || "1";

  const [tournaments, setTournaments] = useState([])
  const [pagination, setPagination] = useState(null)
  const [currentPage, setCurrentPage] = useState(page)
  const [showFlashMessage, setShowFlashMessage] = useState(false)

  const handlePaginationClick = async (newTournamentsPage) => {
    setCurrentPage(newTournamentsPage)

    window.history.replaceState(null, "Bolão: Admin Tournaments", "?page=" + newTournamentsPage)
  }

  const handleDeleteTournamentClick = (tournamentId) => {
    if (window.confirm("Delete?")) {
      deleteTournament(tournamentId).then(deleted => {
        if (deleted) {
          loadTournaments(1)
          window.history.replaceState(null, "Bolão: Admin Tournaments", '')
          setShowFlashMessage(true)
        }
      })
    }
  }

  const handleEditTournamentClick = (tournamentId) => {
    window.location.href = "/cocofantoelefanto/tournaments/" + tournamentId + "/edit"
  }

  const handleMatchesClick = (tournamentId) => {
    window.location.href = "/cocofantoelefanto/tournaments/" + tournamentId + "/matches"
  }

  const handlePlatformPoliciesClick = (tournamentId) => {
    window.location.href = "/cocofantoelefanto/tournaments/" + tournamentId + "/platform-policies"
  }

  useEffect(() => {
    loadTournaments(currentPage)
  }, [currentPage])

  async function loadTournaments(page) {
    const resData = await ListTournamentsAdmin(page)

    setTournaments(resData.data)
    setPagination(resData.pagination)
  }

  return (
    <>
      {showFlashMessage && (
        <Flash message="Tournament was successfully deleted" type="success" timer={5000}/>
      )}
      <table className="w-full text-sm text-left rtl:text-right text-gray-500 mt-4">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
          <tr>
            <th scope="col" className="px-6 py-3">Nome</th>
            <th scope="col" className="px-6 py-3">Edição</th>
            <th scope="col" className="px-6 py-3">Período</th>
            <th scope="col" className="px-6 py-3">API/Season/ID</th>
            <th scope="col" className="px-6 py-3">Actions</th>
          </tr>
        </thead>
        <tbody>
        {tournaments.map((tournament) => {
          return (
            <tr key={tournament.id} className="odd:bg-white even:bg-gray-50 border-b border-gray-200">
              <td className="px-4 py-2">
                <Link className="hover:no-underline underline" to={`/cocofantoelefanto/tournaments/${tournament.id}`}>{tournament.name}</Link>
              </td>
              <td className="px-4 py-2">
                {tournament.edition}
              </td>
              <td className="px-4 py-2">
                {tournament.starts_at} - {tournament.ends_at}
              </td>
              <td className="px-4 py-2">
                {tournament.third_party_label ? tournament.third_party_label : "-"}/{tournament.third_party_season ? tournament.third_party_season : "-"}/{tournament.third_party_id ? tournament.third_party_id : "-"}
              </td>
              <td className="px-4 py-2 space-x-2">
                <Button styleName="yellow" onClick={() => handleEditTournamentClick(tournament.id)}>Edit</Button>
                <Button styleName="red" onClick={() => handleDeleteTournamentClick(tournament.id)}>Delete</Button>
                <Button styleName="green" onClick={() => handleMatchesClick(tournament.id)}>Matches</Button>
                <Button styleName="blue" onClick={() => handlePlatformPoliciesClick(tournament.id)}>Platform Policies</Button>
              </td>
            </tr>
          )
        })}
        </tbody>
      </table>

      <Pagination pagination={pagination} onPaginationClick={handlePaginationClick} />
    </>
  )
}

async function deleteTournament(tournamentId) {
  return await DeleteTournament(tournamentId)
}
